"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgEyeSlash(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M22.765 1.224a.766.766 0 01.074.998l-.074.086L2.34 22.734a.766.766 0 01-1.158-.998l.075-.086 3.362-3.362C1.663 16.49 0 13.786 0 11.978c0-1.387 1.21-3.625 3.021-5.371C5.336 4.377 8.398 3.043 12 3.043c2.546 0 4.68.679 6.096 1.767l3.586-3.586c.299-.299.784-.299 1.083 0zm-1.017 6.201C23.124 8.998 24 10.813 24 11.98c0 1.387-1.21 3.626-3.022 5.372-2.314 2.23-5.376 3.564-8.978 3.564-1.14 0-2.226-.134-3.255-.393a.766.766 0 01.375-1.486c.905.229 1.866.347 2.88.347 3.19 0 5.876-1.17 7.915-3.136 1.54-1.482 2.553-3.358 2.553-4.268 0-.736-.72-2.226-1.873-3.545a.766.766 0 111.153-1.009zM12 4.575c-3.19 0-5.877 1.17-7.916 3.135-1.539 1.483-2.552 3.358-2.552 4.268 0 .409.317 1.313.896 2.198.749 1.144 1.843 2.175 3.309 2.993l2.431-2.43a.763.763 0 01-.361-.319 4.851 4.851 0 017.044-6.365l2.151-2.15C15.863 5.1 14.124 4.575 12 4.575zm4.135 6.64a.766.766 0 01.714.813 5.16 5.16 0 01-4.799 4.8.766.766 0 11-.1-1.529 3.628 3.628 0 003.37-3.37.766.766 0 01.815-.715zM12 8.66a3.32 3.32 0 00-2.87 4.988l.042.086 4.576-4.576A3.3 3.3 0 0012 8.66z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgEyeSlash;
exports.default = _default;